import { Component, computed, Input, signal, Signal, WritableSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { InTransitDetail, StockCounters, StoreStock, StoreStocks } from 'src/app/models/types/Product/Stock.type';
import { StockAndPriceService } from 'src/app/services/api/stock-and-price.service';
import { MyStoreStockComponent } from '../my-store-stock/my-store-stock.component';
import { StockButtonComponent } from '../stock-button/stock-button.component';

@Component({
  selector: 'app-other-store-stock',
  imports: [TranslateModule, MyStoreStockComponent, StockButtonComponent],
  templateUrl: './other-store-stock.component.html',
  styleUrl: './other-store-stock.component.scss'
})
export class OtherStoreStockComponent {

  @Input('storeStocks') storeStocks!: Signal<StoreStocks>;

  private _selectedStock: WritableSignal<StoreStock | null> = signal(null);
  public selectedStock: Signal<StoreStock | null> = computed(() => this._selectedStock());

  public total: Signal<StockCounters> = computed(() => {
    let stocks = this.storeStocks();
    return this.stockAndPriceService.getStoreStockCounterTotal(stocks);
  });

  constructor(public readonly stockAndPriceService: StockAndPriceService) { }

  handleSelectStock(stock: StoreStock | null) {
    this._selectedStock.set(stock);
  }

  getStoreInTransitCount(inTransit: InTransitDetail[] | null) {
    if (inTransit) {
      return inTransit.reduce((acc, curr) => acc + (curr.quantity || 0), 0);
    }
    return '';
  }
}
